import { isManager } from '../../entities/organization';
import { AiUsagePanel } from '../../features/ai-budget';
import { SettingsShell } from './settings-shell';
import { useOrganizationSettings } from './use-organization-settings';

/** Board S4: what AI steps cost, and the daily limit on it. */
export const AiUsagePage = () => {
  const { actor, timeZone } = useOrganizationSettings();

  return (
    <SettingsShell
      active="/settings/ai-usage"
      question="What AI steps cost, and the daily limit on it."
    >
      <AiUsagePanel editable={isManager(actor)} now={Date.now()} timeZone={timeZone} />
    </SettingsShell>
  );
};
